// Módulos
import { createAction, props } from '@ngrx/store';
import {
  IShipAccidentsRequest,
  IShipAccidentsResponse,
  ISortingAndFilteringCriteria,
} from '@accidents/shared/interfaces/ship-accidents';

// ------- ShipAccidents Actions ------
// ---------------------------------------

export const reset = createAction('[Ship Accidents] - Reset');

export const shipAccidentsRequested = createAction(
  '[Ship Accidents] - Ship Accidents Requested',
  props<{ payload: IShipAccidentsRequest }>()
);

export const saveNewSortingAndFilteringCriteria = createAction(
  '[Ship Accidents] - Save new sorting and filtering criteria',
  props<{ payload: ISortingAndFilteringCriteria }>()
);

export const shipAccidentsResponse = createAction(
  '[Ship Accidents] - Ship Accidents Response',
  props<{ payload: IShipAccidentsResponse }>()
);

export const saveNewFilteringAndSortingCriteria = createAction(
  '[Ship Accidents] - Save new Filter and Sorting Criteria',
  props<{ payload: IShipAccidentsRequest }>()
);
